module.exports = __webpack_public_path__ + "media/images/logo-black-4519782e669703e774229b33ede1622d.svg";